<script>
import Layout from '@layouts/main'
import { getHotelInfo, storeHotelInfo, getProductsInfo, getBoarding, storeBoarding } from './api'
export default {
  components: {
    Layout,
  },
  data() {
    return {
      activeTab1: this.$route.query.tab1 || (this.$route.query.name ? null : '0'),
      activeTab2: this.$route.query.tab2 || (this.$route.query.name ? null : '0'),
      name: this.$route.query.name || '',
      boardingForms: null,
      hotelInfo: null,
      productsInfo: null,
      loading: false,
      components: [
        {
          name: 'basic-info',
          component: () => import('@/src/router/views/hotel/TabBasic/Info.vue'),
        },
        {
          name: 'basic-branch-settings',
          component: () => import('@/src/router/views/hotel/TabBasic/BranchSettings.vue'),
        },
        {
          name: 'basic-check-out-time',
          component: () => import('@/src/router/views/hotel/TabBasic/CheckOutTime.vue'),
        },
        {
          name: 'basic-contact',
          component: () => import('@/src/router/views/hotel/TabBasic/Contact.vue'),
        },
        {
          name: 'room',
          component: () => import('@/src/router/views/hotel/TabRoom/Room.vue'),
        },
        {
          name: 'new-room',
          component: () => import('@/src/router/views/hotel/TabRoom/NewRoom.vue'),
        },
        {
          name: 'over-time-price',
          component: () => import('@/src/router/views/hotel/TabSpecialPrice/OverTimePrice.vue'),
        },
        {
          name: 'modify-price',
          component: () => import('@/src/router/views/hotel/TabSpecialPrice/ModifyPrice.vue'),
        },
        {
          name: 'long-stay-price',
          component: () => import('@/src/router/views/hotel/TabSpecialPrice/LongStayPrice.vue'),
        },
        {
          name: 'addon',
          component: () => import('@/src/router/views/hotel/TabAddon/Addon.vue'),
        },
        {
          name: 'accommodation',
          component: () => import('@/src/router/views/hotel/TabAccommodation/Accommodation.vue'),
        },
        {
          name: 'qa',
          component: () => import('@/src/router/views/hotel/TabQA/QA.vue'),
        },
      ],
      tabList: Object.freeze([
        {
          title: '基本設定',
          tabList: Object.freeze([
            {
              title: '資訊設定',
              component: 'basic-info',
            },
            {
              title: '分店設定',
              component: 'basic-branch-settings',
            },
            // {
            //   title: '入住退房時間設定',
            //   component: 'basic-check-out-time',
            // },
            // {
            //   title: '聯絡簿設定',
            //   component: 'basic-contact',
            // },
          ]),
        },
        {
          title: '控房系統',
          component: 'room',
        },
        // {
        //   title: '特殊房價',
        //   tabList: Object.freeze([
        //     {
        //       title: '超時與額外收費',
        //       component: 'over-time-price',
        //     },
        //     {
        //       title: '調價設定',
        //       component: 'modify-price',
        //     },
        //     {
        //       title: '連續住宿優惠',
        //       component: 'long-stay-price',
        //     },
        //   ]),
        // },
        {
          title: '住宿單',
          component: 'accommodation',
        },
        {
          title: '加購商品',
          component: 'addon',
        },
        // {
        //   title: '相關問答',
        //   component: 'qa',
        // },
      ]),
    }
  },
  computed: {
    currentTab1() {
      return this.tabList[this.activeTab1]
    },
    currentTab2() {
      if (!this.currentTab1) {
        return null
      }
      return this.currentTab1.tabList?.[this.activeTab2] || this.currentTab1.tabList?.[0]
    },
    currentComponent() {
      const foundNamedComponent = this.components.find((component) => component.name === this.name)
      if (foundNamedComponent) {
        return foundNamedComponent
      }
      if (this.currentTab2) {
        return this.components.find((component) => component.name === this.currentTab2.component)
      }
      if (this.currentTab1) {
        return this.components.find((component) => component.name === this.currentTab1.component)
      }
    },
  },
  watch: {
    currentTab1() {
      this.activeTab2 = '0'
    },
    currentComponent(component) {
      if (this.currentTab1?.component === component.name) {
        this.$router.push({
          query: {
            tab1: `${this.tabList.indexOf(this.currentTab1)}`,
          },
        })
        return
      }
      if (this.currentTab2?.component === component.name) {
        this.$router.push({
          query: {
            tab1: `${this.tabList.indexOf(this.currentTab1)}`,
            tab2: `${this.currentTab1.tabList.indexOf(this.currentTab2)}`,
          },
        })
        return
      }

      this.$router.push({
        query: {
          name: component.name,
        },
      })
    },
    '$route.query': {
      handler(newValue) {
        if (this.$route.name != 'hotel') {
          return
        }
        this.activeTab1 = newValue.tab1 || (newValue.name ? null : '0')
        this.activeTab2 = newValue.tab2 || (newValue.name ? null : '0')
        this.name = newValue.name || null
      },
      deep: true,
    },
  },
  async created() {
    this.loading = true ;
    //取得住宿設定
    await this.fetchHotelInfo()
    //取得住宿題目
    await this.fetchBoardingForms()
    this.loading = false ;
  },
  methods: {
    async fetchHotelInfo() {
      try {
        this.loading = true
        const hotelInfo = await getHotelInfo()
        const productsInfo = await getProductsInfo()
        this.hotelInfo = hotelInfo
        this.syncProductSetting(productsInfo, this.hotelInfo)
        this.productsInfo = productsInfo
        this.buildProductMap(productsInfo)
        // 觸發更新事件，讓子組件可以接收資料
        this.$nextTick(() => {
          this.$emit('hotel-info-updated', hotelInfo)
        })
      } catch (error) {
        console.error('獲取旅館資訊失敗:', error)
      } finally {
        this.loading = false
      }
    },
    async saveHotelInfo(payload) {
      try {
        this.loading = true
        await storeHotelInfo(payload)
        this.$message?.success?.('儲存成功')
        await this.fetchHotelInfo()
      } catch (error) {
        console.error('儲存旅館資訊失敗:', error)
        this.$message?.error?.('儲存失敗')
      } finally {
        this.loading = false
      }
    },
    syncProductSetting(productsInfo, hotelInfo) {
      if (!productsInfo?.items || !Array.isArray(productsInfo.items)) return
      if (!Array.isArray(hotelInfo.productSetting)) {
        hotelInfo.productSetting = []
      }

      // 已存在的 productId 集合
      const existProductIds = new Set(hotelInfo.productSetting.map((item) => item.productId))

      productsInfo.items.forEach((product) => {
        if (!existProductIds.has(product.id)) {
          hotelInfo.productSetting.push({
            productId: product.id,
            isEnable: 0,
          })
        }
      })
    },
    buildProductMap(productsInfo) {
      if (!productsInfo?.items) return {}
      const map = {}
      productsInfo.items.forEach((product) => {
        map[product.id] = product
      })
      this.productMap = map
    },
    getProductById(productId) {
      return this.productMap?.[productId] || null
    },
    getProductName(productId) {
      return this.productMap?.[productId]?.name || '（未知商品）'
    },
    async onStoreBoardingForm(payload, resolve, reject) {
      try {
        this.loading = true
        const res = await storeBoarding(payload)
        resolve(res) // ✅ 回傳給子層 saveQuestion() 用
        this.fetchBoardingForms();
      } catch (e) {
        this.$message?.error?.('儲存失敗')
        reject(e)
      } finally {
        this.loading = false
      }
    },
    async fetchBoardingForms() {
      try {
        this.loading = true
        const items = await getBoarding()
        this.boardingForms = Array.isArray(items) ? items : []
      } catch (e) {
        console.error(e)
        this.$message?.error?.('載入住宿單表單失敗')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div :class="$style.page">
      <template v-if="currentTab1">
        <el-tabs v-model="activeTab1" stretch type="border-card" class="isStyleBase">
          <el-tab-pane v-for="(tab1, index1) in tabList" :key="index1" :label="tab1.title" :name="`${index1}`"> </el-tab-pane>
        </el-tabs>
      </template>
      <template v-if="currentTab2">
        <el-tabs v-model="activeTab2" stretch class="is-no-border isStyleBaseLine isSecond">
          <el-tab-pane v-for="(tab2, index2) in currentTab1.tabList" :key="index2" :label="tab2.title" :name="`${index2}`"> </el-tab-pane>
        </el-tabs>
      </template>
      <div :class="$style.basicSetForm" style="margin-bottom: 80px">
        <component
          v-if="currentComponent && hotelInfo && productsInfo"
          :is="currentComponent.component"
          :products-info="productsInfo"
          :get-product-name="getProductName"
          :hotel-info="hotelInfo"
          :loading="loading"
          :boarding-forms="boardingForms"
          @save="saveHotelInfo"
          @store-form="onStoreBoardingForm"
        />
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
.basicSetForm {
  // overflow: scroll;
  // width: 100%;
  // padding: 18px 20px 0;
}
</style>
